import { Box, Pagination, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { useError } from 'contexts/error';
import { usePaginate } from 'contexts/paginate';
import { WhiteCard } from 'components/styles_components/card';
import InfoContainer from 'components/info_container';
import LoaderContainer from 'components/layout/loader_container';
import SpaceOrdersQuery from 'queries/space/orders';
import Index from 'components/space/order/index';

const IndexContainer = () => {
  const { page, onPageChange } = usePaginate();
  const setError = useError();
  const { data = { spaceOrders: { spaceOrders: [], perPage: 10 } }, loading } = useQuery(
    SpaceOrdersQuery,
    {
      variables: { page },
      cachePolicy: 'no-cache',
      onError: () => {
        setError('error.space.orders.index');
      },
    }
  );

  return (
    <WhiteCard>
      <LoaderContainer loading={loading} wrap={false}>
        <Typography variant="h6">
          <FormattedMessage id="space.orders" />
        </Typography>
        <InfoContainer visible={data.spaceOrders.spaceOrdersTotal === 0}>
          <FormattedMessage id="empty.space.orders.title.short" />
        </InfoContainer>
        <Index orders={data.spaceOrders.spaceOrders} />
        <Box display="flex" justifyContent="center">
          {data.spaceOrders.spaceOrdersTotalPages > 1 && (
            <Pagination
              count={data.spaceOrders.spaceOrdersTotalPages}
              page={page}
              onChange={(_e, nextPage) => {
                onPageChange(nextPage);
              }}
            />
          )}
        </Box>
      </LoaderContainer>
    </WhiteCard>
  );
};

export default IndexContainer;
